import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { TooltipTrigger as TooltipTriggerPrimitive, type TooltipTriggerProps } from 'reka-ui';


export default /*@__PURE__*/_defineComponent({
  __name: 'TooltipTrigger',
  props: {
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TooltipTriggerPrimitive), _mergeProps(_ctx.$props, { "as-child": "" }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})